const size = {
  desktopSm: "1280px",
  desktopMd: "1440px",
  desktopL: "1920px"
};

export const screens = {
  desktopSm: `(max-width: ${size.desktopSm})`,
  desktopMd: `(max-width: ${size.desktopMd})`,
  desktopL: `(max-width: ${size.desktopL})`
};
